import { styled } from "styled-components";

const Step4 = ({ service, order }) => {
  return (
    <Container>
      <RowContainer>
        <RowTitle>Service:</RowTitle>
        <RowValue>{service.title}</RowValue>
      </RowContainer>

      <RowContainer>
        <RowTitle>Price:</RowTitle>
        <RowValue>£{service.price}</RowValue>
      </RowContainer>

      <RowContainer>
        <RowTitle>Type:</RowTitle>
        <RowValue>{order.serviceType}</RowValue>
      </RowContainer>

      <RowContainer>
        <RowTitle>App URL:</RowTitle>
        <RowValue>{order.websiteUrl || "Not provided"}</RowValue>
      </RowContainer>
    </Container>
  );
};

const Container = styled.div``;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RowTitle = styled.p`
  font-weight: 700;
  font-size: 15px;
  color: #ff6341;
`;

const RowValue = styled.p`
  font-size: 14px;
`;

export default Step4;
